<template>
  <div
    v-disableable="{blur: true, dim: true, disabled: onTour}"
    class="menu-footer-container"
  >
    <div
      v-if="partnerLogo"
      class="partner-container"
    >
      <img
        :src="partnerLogo"
        alt="logo"
      >
    </div>
    <div
      v-disableable="{blur: true, dim: true, disabled: onTour}"
      class="copyright"
    >
      ©{{ currentYear }} Higher Learning Technologies<br>All Rights Reserved
    </div>
    <div class="legal-links">
      <a
        target="_blank"
        class="legal"
        href="https://hltmastery.com/privacy"
      >Privacy Policy</a>
      |
      <router-link
        class="legal"
        :to="{name: 'eula'}"
      >
        EULA
      </router-link>
    </div>
  </div>
</template>

<script>
import GlobalMixin from '@/mixins/global';

export default {
  mixins: [GlobalMixin],
  props: {
    onTour: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    partnerLogo() {
      return this.$store.getters['app/partnerLogo'];
    },
  },
};
</script>

<style lang="scss" scoped>
  .menu-footer-container {
    margin-top: auto;
    text-align: center;

    .partner-container {
      margin: 0 auto;
      width: rem-calc(180);
      height: rem-calc(180);

      img {
        width: 100%;
      }
    }

    .copyright {
      line-height: rem-calc(11);
    }

    .copyright, .legal-links {
      font-size: rem-calc(10);
      color: #7F8FA4;
      margin-bottom: rem-calc(6);

      a {
        color: #7F8FA4;
        text-decoration: none;
      }
    }
  }
</style>
